import { render } from "./NewCandidacy.vue?vue&type=template&id=274739e0&scoped=true"
import script from "./NewCandidacy.vue?vue&type=script&lang=js"
export * from "./NewCandidacy.vue?vue&type=script&lang=js"

import "./NewCandidacy.vue?vue&type=style&index=0&id=274739e0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeia-spa/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274739e0"]])

export default __exports__